import { ChangeDetectorRef, Component, EventEmitter, IterableDiffers, Output, ChangeDetectionStrategy } from '@angular/core';
import { ListViewColumnFactory } from '../../../service/factory/list-view-column-factory.service';
import { ListViewBase } from '../list-view.base';
import { DefaultPageSize, PagingEvent } from '../paging/paging.component';
import { LanguageService } from '../../../service/language.service';

// TODO: is this component unused..?
@Component({
    selector: 'app-toogle-list-view',
    templateUrl: './toogle-list-view.component.html',
    styleUrls: ['./toogle-list-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ToogleListViewComponent extends ListViewBase {
  constructor(
    private _cdr: ChangeDetectorRef,
    columnFactory: ListViewColumnFactory,
    languageService: LanguageService,
    iterableDiffers: IterableDiffers
  ) {
    super(columnFactory, languageService, iterableDiffers);
  }

  @Output() toggleChanged = new EventEmitter<{ value: boolean; data: any }>();
  from: number = 0;
  to: number = DefaultPageSize;

  onToggleChanged(value: boolean, data: any) {
    setTimeout(() => {
      this.toggleChanged.emit({ value, data });
      this._cdr.detectChanges();
    });
    this.toggleChanged.emit({ value, data });
  }

  pagingChanged(e: PagingEvent) {
    this.from = e.from;
    this.to = e.to;
  }
}
